const updateQueryParameters = (queryParameters, filters, field, item, add) => {
  const values = filters[field];

  if (add) {
    return {
      ...queryParameters,
      [field]: [...values, item].toString(),
    };
  }

  const valuesWithoutItem = values.filter((value) => value !== item);
  const { [field]: _value, ...rest } = queryParameters;

  return {
    ...rest,
    ...(valuesWithoutItem.length > 0
      ? { [field]: valuesWithoutItem.toString() } : {}),
  };
};

export default updateQueryParameters;
